import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikIgangvaerende } from '../../models/StatistikIgangvaerende';
import { StatistikIgangvaerendeKundeFaktura } from '../../models/StatistikIgangvaerendeKundeFaktura';
import { InvoiceContainerComponent } from '../../../invoices/invoice/invoice.container';

@Component({
    selector: 'app-statistik-igangvaerende-faktura-modal-ui',
    templateUrl: './statistik-igangvaerende-faktura-modal.html',
    styleUrls: ['./statistik-igangvaerende-faktura-modal.scss'],
    standalone: false
})
export class StatistikIgangvaerendeFakturaModal {
    @Input() kunde: StatistikIgangvaerende;
    @Input() statistikIgangvaerendeKundeFaktura: StatistikIgangvaerendeKundeFaktura[];
    @Input() date: string;

    constructor(private activeModal: NgbActiveModal,
                private modalService: NgbModal) {}

    onDismiss() {
        this.activeModal.dismiss();
    }

    onInvoice(fnr: number, kid: number) {
        const invoiceModal = this.modalService.open(InvoiceContainerComponent, {size: 'lg', backdrop: 'static', scrollable: true});
        invoiceModal.componentInstance.fnr = fnr;
        invoiceModal.componentInstance.kid = kid;
    }


    GetTotalBeloeb(): number {
        let total = 0;
        this.statistikIgangvaerendeKundeFaktura.forEach(value => {
            total += value.beloeb;
        });
        return total;
    }
}
